import React from "react";
import { Lock, Trash2 } from "lucide-react";
import { useI18n } from "@/lib/i18n";

/** Appears once galleries are checkbox-selected: move to folder, batch delete, clear. */
export const BatchActionBar = ({ count, folders, locked, onMove, onDelete, onClear }) => {
  const { t } = useI18n();

  if (count === 0) return null;

  return (
    <div className="flex flex-wrap items-center gap-3 mb-6 border border-[#D4AF37]/40 bg-[#D4AF37]/5 p-4"
      data-testid="batch-bar">
      <span className="font-mono-accent text-[10px] tracking-[0.16em] uppercase text-[#D4AF37]"
        data-testid="batch-count">{t("selected_count", { n: count })}</span>
      <select data-testid="batch-move-select" defaultValue=""
        onChange={(e) => { if (e.target.value !== "") onMove(e.target.value === "none" ? "" : e.target.value); }}
        className="select-dark text-base sm:text-[10px] min-h-[44px] sm:min-h-0">
        <option value="">{t("move_to_folder")}</option>
        <option value="none">{t("unfiled")}</option>
        {folders.map((f) => <option key={f.folder_id} value={f.folder_id}>{f.name}</option>)}
      </select>
      <button data-testid="batch-delete-btn" onClick={onDelete}
        className="inline-flex items-center gap-2 border border-[#8B0000] text-[#8B0000] px-4 py-2 text-[10px] tracking-[0.16em] uppercase hover:bg-[#8B0000]/10">
        {locked ? <Lock size={12} /> : <Trash2 size={12} />} {t("delete_selected")}
      </button>
      <button data-testid="batch-clear-btn" onClick={onClear}
        className="text-[10px] tracking-[0.16em] uppercase text-[#707070] hover:text-[#F3F3F1]">
        {t("clear_selection")}
      </button>
    </div>
  );
};
